import './GenerateQuestionDialogHeader.scss';

import type { ComponentProps, ReactElement } from 'react';
import * as React from 'react';

import { translate } from '@showbie-socrative/socrative-utils/lib/translator/client';

import { Badge } from '~shared/components/Badge';
import { IconButton } from '~shared/components/buttons';
import { IconChevron } from '~shared/components/icons/large';
import { LearnMoreIcon } from '~teacher/components/QuizEditor/GenerateQuestionDialog/LearnMoreIcon';

interface GenerateQuestionDialogContentProps {
  children: React.ReactNode;
  header: ReactElement<ComponentProps<typeof GenerateQuestionDialogHeader>>;
  footer?: ReactElement<ComponentProps<typeof GenerateQuestionsDialogFooter>>;
}

interface GenerateQuestionsDialogFooterProps {
  children: React.ReactNode;
}
export function GenerateQuestionsDialogFooter({
  children,
}: GenerateQuestionsDialogFooterProps) {
  return (
    <div className="pl-5">
      <div className="shadow-inset-border-t">{children}</div>
    </div>
  );
}

export interface GenerateQuestionDialogHeaderProps {
  title: React.ReactNode;
  description: React.ReactNode;
  isPro?: boolean;
  onBack?: () => void;
}

export function GenerateQuestionDialogHeader({
  title,
  description,
  isPro = true,
  onBack,
}: GenerateQuestionDialogHeaderProps) {
  return (
    <div className="pl-5">
      <div className="pb-4 sticky top-0 z-50 bg-white generate-content-header shadow-inset-border-b">
        {onBack ? (
          <div className="back">
            <IconButton aria-label={translate('Back')} onClick={onBack}>
              <IconChevron direction="left" />
            </IconButton>
          </div>
        ) : null}
        <div className="title">
          <div className="flex">
            <Badge textTransform="capitalize" tone="ai">
              {translate('AI Assisted')}
              <LearnMoreIcon />
            </Badge>
          </div>
          <div className="flex items-center gap-1 font-display text-md leading-normal text-blue-900 font-700">
            {title} {isPro ? '' : <Badge className='font-sans'>Pro</Badge>}
          </div>
          <div className="text-sans text-base leading-normal text-blue-600">
            {description}
          </div>
        </div>
      </div>
    </div>
  );
}

export function GenerateQuestionDialogContent({
  children,
  header,
  footer,
}: GenerateQuestionDialogContentProps) {
  return (
    <div className="flex flex-col h-full overflow-hidden">
      <div className="flex-none">{header}</div>
      <div className="flex-1 overflow-y-auto min-h-0 pl-5 pr-1">{children}</div>
      {footer ? <div className="flex-none">{footer}</div> : null}
    </div>
  );
}

GenerateQuestionDialogContent.Header = GenerateQuestionDialogHeader;
GenerateQuestionDialogContent.Footer = GenerateQuestionsDialogFooter;